export default __webpack_public_path__ + "static/media/card3.74be7770.png";